import favicon from '../../common/app/favicon'

export default {
  title: '%s | Dopravní akademie a.s.',
  metas: [
    { charset: 'utf-8' },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, shrink-to-fit=no',
    },
    {
      'http-equiv': 'x-ua-compatible',
      content: 'ie=edge',
    },
    {
      name: 'description',
      content: 'Dopravní akademie',
    },
    ...favicon.meta,
  ],
  links: favicon.link,
}



// WEBPACK FOOTER //
// ./src/browser/app/meta.js